
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#fff"}},[_c('path',{attrs:{"d":"M10.852 9.68a.612.612 0 01-.597.626H4.872a.612.612 0 01-.598-.625c0-.346.268-.625.598-.625h5.383c.33 0 .597.28.597.625zM4.888 7.806a.62.62 0 01-.614-.625.62.62 0 01.614-.625h6.461c.34 0 .614.28.614.625a.62.62 0 01-.614.625H4.89zM4.9 5.694a.625.625 0 110-1.25h4.798a.625.625 0 110 1.25H4.899z"}}),_c('path',{attrs:{"d":"M7.257 1.25h-2.98c-.688 0-1.25.56-1.25 1.25v11c0 .69.562 1.25 1.25 1.25h7.685c.69 0 1.25-.56 1.25-1.25V6.99a.625.625 0 111.25 0v6.51c0 1.379-1.122 2.5-2.5 2.5H4.278a2.503 2.503 0 01-2.5-2.5v-11c0-1.379 1.121-2.5 2.5-2.5h2.979a.625.625 0 110 1.25z"}}),_c('path',{attrs:{"d":"M11.337 12.806H4.899a.625.625 0 110-1.25h6.438a.625.625 0 110 1.25zM14.222 4.444C14.222 2 12.222 0 9.778 0v2.778c0 .944.722 1.666 1.666 1.666h2.778z"}})])])
          )
        }
      }
    